import { render, staticRenderFns } from "./TagManagerTags.template.vue?vue&type=template&id=c07f351c&scoped=true&"
var script = {}
import style0 from "./TagManagerTags.template.vue?vue&type=style&index=0&id=c07f351c&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07f351c",
  null
  
)

export default component.exports